import React, { PropsWithChildren } from 'react';

import { Box } from '@betterment/samba-react';
import { RecipeVariantProps, cva } from '@betterment/samba-styled-system/css';

const detailRow = cva({
  base: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  variants: {
    variant: {
      default: {},
      weak: {
        textStyle: 'text50',
        color: 'text.weak',
      },
    },
  },
});

type DetailRowProps = RecipeVariantProps<typeof detailRow>;

export const DetailRow: React.FC<PropsWithChildren<DetailRowProps>> = ({ variant = 'default', children, ...props }) => {
  return (
    <Box css={detailRow.raw({ variant })} {...props}>
      {children}
    </Box>
  );
};
